import { Skeleton } from '../ui'

interface TableSkeletonProps {
  rows?: number
}

export default function TableSkeleton({ rows = 5 }: TableSkeletonProps) {
  return (
    <div className="space-y-3 p-2">
      <div className="flex gap-4">
        <Skeleton className="h-6 flex-1" />
        <Skeleton className="h-6 flex-1" />
        <Skeleton className="h-6 flex-1" />
        <Skeleton className="h-6 w-24" />
      </div>
      {Array.from({ length: rows }).map((_, i) => (
        <div key={i} className="flex gap-4">
          <Skeleton className="h-8 flex-1" />
          <Skeleton className="h-8 flex-1" />
          <Skeleton className="h-8 flex-1" />
          <Skeleton className="h-8 w-24" />
        </div>
      ))}
    </div>
  )
}
